<template>
  <vetster-dynamic-geo-vet-list
    :search-type="searchType"
    :species-types="speciesType"
  />
</template>

<script>
import VetsterDynamicGeoVetList from '@/components/VetsterDynamicGeoVetList';

export default {
  name: 'VetsterVetPartner',

  components: { VetsterDynamicGeoVetList },

  props: {
    searchType: {
      type: String,
      default: null,
    },
    speciesType: {
      type: Array,
      default: null,
    },
  },
};
</script>
